import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Share from '../components/Share';
import './Jobs.css';

const applicationHref = `mailto:kei@sugano.works?subject=${encodeURIComponent('ASMRキリスト教会 声優募集への応募')}`;

function JobVoiceActor() {
  return (
    <div className="body">
      <Header
        title="Jobs・声優募集 | ASMRキリスト教会"
        description="ASMRキリスト教会では、日曜のオンライン礼拝で司会進行・出演を担当する声優を2名募集しています。月4回、1回約1時間。月額10,000円、契約期間1年。"
        url="https://www.asmrchurch.com/jobs/voice-actor"
        image="https://www.asmrchurch.com/static/images/kirikan-jobs-studio-amen.png"
        subon={false}
      />
      <main className="jobs-page">
        <nav className="jobs-breadcrumb" aria-label="パンくずリスト">
          <a href="/jobs">Jobs・仕事一覧</a><span aria-hidden="true"> / </span><span>声優募集</span>
        </nav>
        <header className="jobs-hero">
          <img
            className="jobs-hero-image"
            src="/static/images/kirikan-jobs-studio-amen.png"
            alt="スタジオでヘッドホンを着け、バイノーラルマイクで収録するキリカン"
            width="1536"
            height="1024"
          />
          <p className="jobs-eyebrow">Jobs / 声優募集</p>
          <h1>ASMRキリスト教会<br />声優募集</h1>
          <p className="jobs-intro">
            日曜のオンライン礼拝に、あなたの声を。<br />
            毎週日曜に行う主日礼拝の司会進行・出演を担当する声優を募集しています。
          </p>
          <a className="jobs-apply" href={applicationHref}>メールで応募する</a>
        </header>

        <section className="jobs-section" aria-labelledby="jobs-details">
          <h2 id="jobs-details">募集概要</h2>
          <dl className="jobs-details">
            <div><dt>業務内容</dt><dd>ASMRキリスト教会主日礼拝の司会進行・出演。YouTube Liveでオンライン礼拝を配信します。</dd></div>
            <div><dt>配信頻度・時間</dt><dd>日曜日・月4回（1回1時間程度）</dd></div>
            <div><dt>契約期間</dt><dd>1年</dd></div>
            <div><dt>募集人数</dt><dd>2名</dd></div>
            <div><dt>報酬</dt><dd>月額10,000円（1回あたり2,500円）<br /><span className="jobs-note">能力に応じて応相談</span></dd></div>
          </dl>
        </section>

        <section className="jobs-section" aria-labelledby="jobs-requirements">
          <h2 id="jobs-requirements">応募要件（必須）</h2>
          <ul>
            <li>声がかわいいこと</li>
            <li>月4回、必ず配信できること</li>
            <li>本社に1回来られること</li>
          </ul>
        </section>

        <section className="jobs-section" aria-labelledby="jobs-notes">
          <h2 id="jobs-notes">備考</h2>
          <ul>
            <li>PC貸与あり。</li>
            <li>キリスト教徒の方は歓迎しますが、必須ではありません。</li>
            <li>配信内で、ご自身のSNSやコンテンツを宣伝できます。</li>
          </ul>
        </section>

        <section className="jobs-contact" aria-labelledby="jobs-application">
          <h2 id="jobs-application">応募・お問い合わせ</h2>
          <p>ご興味のある方は、下記メールアドレスまでご連絡ください。</p>
          <a className="jobs-email" href={applicationHref}>kei@sugano.works</a>
          <a className="jobs-apply" href={applicationHref}>メールで応募する</a>
        </section>
        <div className="jobs-share">
          <Share
            label="この募集をシェアする"
            title="声優募集・オンライン礼拝の司会進行／出演 | ASMRキリスト教会"
            url="https://www.asmrchurch.com/jobs/voice-actor"
            text="日曜のオンライン礼拝に出演する声優を2名募集。月4回、1回約1時間。月額10,000円（能力に応じて応相談）、PC貸与あり。"
            image="https://www.asmrchurch.com/static/images/kirikan-jobs-studio-amen.png"
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default JobVoiceActor;
